'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import PagosRegistradosRow from "./PagosRegistradosRow.jsx"

class PagosRegistradosModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { fechasCierreUltimaCartera, origenCanalPago, pagosRegistradosPesos, pagosRegistradosDolares } = this.props;

        const pagosRegistradosPesosRow = pagosRegistradosPesos.map((pagoRegistrado) =>
            <PagosRegistradosRow pagoRegistrado={pagoRegistrado} />);

        const pagosRegistradosDolaresRow = pagosRegistradosDolares.map((pagoRegistrado) =>
            <PagosRegistradosRow pagoRegistrado={pagoRegistrado} />);

        return <div className="container-fluid saldos-resumenes">
            <table className="table">
                <thead>
                    <tr>
                        <th>
                            <label className="label-saldos-resumenes-header">FECHA</label>
                        </th>
                        <th>
                            <label className="label-saldos-resumenes-header">ORIGEN / CANAL</label>
                        </th>
                        <th>
                            <label className="label-saldos-resumenes-header">IMPORTE $</label>
                        </th>
                        <th>
                            <label className="label-saldos-resumenes-header">IMPORTE U$S</label>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {pagosRegistradosPesosRow}
                    {pagosRegistradosDolaresRow}
                </tbody>
            </table>
        </div>
    }

}
export default PagosRegistradosModal;